import React from 'react';
import { HeaderNavigationProps } from './HeaderBrand';
import BackToPropertiesButton from './BackToPropertiesButton';
import HotelSelector from './HotelSelector';

interface HeaderHotelNavigationProps extends HeaderNavigationProps {
    isHotelPresentation: boolean;
}

const HeaderHotelNavigation = ({
    isHotelPresentation,
    onBackToList,
    ...navigationProps
}: HeaderHotelNavigationProps) => {
    return (
        <div className='zitoneo-header__hotel-navigation'>
            <BackToPropertiesButton
                {...navigationProps}
                onClick={onBackToList}
            />
            <HotelSelector isInHotelPresentation={isHotelPresentation} />
        </div>
    );
};

export default HeaderHotelNavigation;
